import React, { Component } from 'react';
import { DataDocument, TYPES_DOCUMENT } from '../../data/DataDocument';
import { DataDocumentOperationCategorie } from '../../data/DataDocumentOperationCategorie';
import { DataDocumentOperationType } from '../../data/DataDocumentOperationType';
import { DataDocumentReservationCategorie } from '../../data/DataDocumentReservationCategorie';
import { DataDocumentReservationType } from '../../data/DataDocumentReservationType';
import { Immocom } from '../../specifique/immocom';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxDocument extends Component {

    static defaultProps = {
        categorie: undefined, idCategorie: undefined, // L'un ou l'autre : idCategorie récupéré en BDD via categorie si idCategorie non renseigné
        idOperation: 0,
        inclureDocumentsActifs: true,
        inclureDocumentsDePerimetreSuperieur: true,
        inclureDocumentsInactifs: false,
        label: "Document",
        placeholder: "Document",
        sousCategorie: undefined, idSousCategorie: undefined, // L'un ou l'autre : idSousCategorie récupéré en BDD via sousCategorie si idSousCategorie non renseigné
        type: undefined, // Operation ou Reservation
    };

    constructor(props) {
        super(props);
        this.state = {};
    };

    _chargementIdCategorie = () => {
        this.setState(
            { idCategorie: undefined, idSousCategorie: undefined },
            () => {
                const { type, categorie, sousCategorie } = this.props;

                let fetchMethod = null;
                if (type === TYPES_DOCUMENT.OPERATION) fetchMethod = () => DataDocumentOperationCategorie._getDocumentOperationCategorieByName(categorie);
                else if (type === TYPES_DOCUMENT.RESERVATION) fetchMethod = () => DataDocumentReservationCategorie._getDocumentReservationCategorieByName(categorie);

                if (!!fetchMethod) fetchMethod().then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const documentCategorie = responseFetch.reponseAPIobjet || {};
                        const { idDocumentOperationCategorie, idDocumentReservationCategorie } = documentCategorie;

                        const state = { idCategorie: idDocumentOperationCategorie || idDocumentReservationCategorie };
                        const callback = !!sousCategorie ? this._chargementIdSousCategorie : null;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, callback);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    }
                });
            })
    };

    _chargementIdSousCategorie = () => {
        this.setState(
            { idSousCategorie: undefined },
            () => {
                const { type, sousCategorie } = this.props;
                const { idCategorie } = this.state;

                let fetchMethod = null;
                if (type === TYPES_DOCUMENT.OPERATION) fetchMethod = () => DataDocumentOperationType._getDocumentOperationSousCategorieByName(idCategorie, sousCategorie);
                else if (type === TYPES_DOCUMENT.RESERVATION) fetchMethod = () => DataDocumentReservationType._getDocumentReservationSousCategorieByName(idCategorie, sousCategorie);

                if (!!fetchMethod) fetchMethod().then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const documentCategorie = responseFetch.reponseAPIobjet || {};
                        const { idDocumentOperationType, idDocumentReservationType } = documentCategorie;
                        const state = { idSousCategorie: idDocumentOperationType || idDocumentReservationType };
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    }
                });
            })
    };

    componentDidMount = () => {
        this._chargementIdCategorie();
    };

    componentDidUpdate = (prevProps) => {
        const { type, categorie, sousCategorie } = this.props;

        if (prevProps.type !== type || prevProps.categorie !== categorie) {
            if (!!categorie) this._chargementIdCategorie();
        }
        else if (prevProps.sousCategorie !== sousCategorie) {
            if (!!categorie && !!sousCategorie) this._chargementIdSousCategorie();
        }
    };

    render = () => {

        const { idOperation, inclureDocumentsActifs, inclureDocumentsInactifs, inclureDocumentsDePerimetreSuperieur } = this.props;
        const idSousCategorie = this.props.idSousCategorie || this.state.idSousCategorie;

        let fetchMethod, extractItems;

        if (!!idSousCategorie && !!idOperation) {
            const filtres = { idOperation, idSousCategorie, inclureDocumentsActifs, inclureDocumentsInactifs, inclureDocumentsDePerimetreSuperieur };
            fetchMethod = () => DataDocument._chargementDesDocuments(filtres);
            extractItems = EUIComboBox.defaultProps.extractItems;
        }

        return <EUIComboBox
            {...this.props}
            extractItems={extractItems}
            fetchMethod={fetchMethod}
            itemKey={item => item.rowGUID}
            itemText={item => item.nom}
            stamp={[idOperation, idSousCategorie, inclureDocumentsActifs, inclureDocumentsInactifs, inclureDocumentsDePerimetreSuperieur]}
        />;

    };

};